import { Translate } from '@travel/translation';
import { FlatButton } from '@travel/ui';

import Dialog from 'components/CustomDialog/Dialog/index';
import { selectPopupErrorLabel } from 'store/commonError/selectors';

import { useAppSelector } from 'store/hooks';

import styles from './errorDialog.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export default function ErrorDialog(props: Props) {
  const { isOpen, onClose } = props;

  const errorLabelId = useAppSelector(selectPopupErrorLabel);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      isClosableByClickingOutside
      shouldCloseOnEscPress
      className={styles.errorDialog}
      contentClassName={styles.errorDialogContent}
    >
      <h1 className={styles.title}>
        <Translate id="PostReview.Form.Modal.Error.Title" />
      </h1>
      <p className={styles.message}>
        <Translate id={errorLabelId || 'Review.Common.Error'} />
      </p>
      <FlatButton className={styles.closeBtn} onClick={onClose}>
        <Translate id="Review_Common.Close" />
      </FlatButton>
    </Dialog>
  );
}
